export default __webpack_public_path__ + "static/media/building.9d337f29.png";